import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format, parseISO, isValid } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formatea una fecha en diferentes formatos
 * @param dateInput - Fecha como string ISO, Date object, o string en formato YYYY-MM-DD
 * @param formatStr - Formato deseado (por defecto 'yyyy-MM-dd')
 * @returns Fecha formateada como string
 */
export function formatDate(
  dateInput: string | Date | null | undefined, 
  formatStr: string = 'yyyy-MM-dd'
): string {
  if (!dateInput) return '';
  
  try {
    let date: Date;
    
    if (dateInput instanceof Date) {
      date = dateInput;
    } else if (typeof dateInput === 'string') {
      // Intentar parsear como ISO string primero
      if (dateInput.includes('T') || dateInput.includes('Z')) {
        date = parseISO(dateInput);
      } else {
        // Asumir formato YYYY-MM-DD
        const [year, month, day] = dateInput.split('-').map(Number);
        date = new Date(year, month - 1, day);
      }
    } else {
      return '';
    }
    
    if (!isValid(date)) {
      return '';
    }
    
    return format(date, formatStr);
  } catch (error) {
    console.warn('Error formateando fecha:', error);
    return '';
  }
}

/**
 * Formatea una fecha para mostrar en formato español (dd/MM/yyyy)
 * @param dateInput - Fecha como string ISO, Date object, o string en formato YYYY-MM-DD
 * @returns Fecha formateada en español
 */
export function formatDateSpanish(dateInput: string | Date | null | undefined): string {
  return formatDate(dateInput, 'dd/MM/yyyy');
}

/**
 * Formatea una fecha para mostrar en formato ISO (yyyy-MM-dd)
 * @param dateInput - Fecha como string ISO, Date object, o string en formato YYYY-MM-DD
 * @returns Fecha formateada en formato ISO
 */
export function formatDateISO(dateInput: string | Date | null | undefined): string {
  return formatDate(dateInput, 'yyyy-MM-dd');
}
